import { useState, useEffect, useRef } from "react";
import ScrollContainer from "react-indiana-drag-scroll";
import { CommonCategory } from '@/components/common/category';
import { TagButton, PlayButton } from '@/components/common/button';
import { HeaderBack } from '@/components/common/header';
import { PhoneCallListModal, VideoModal } from "../modal";
import _ from "lodash";
import { DealerSection } from "../dealer";
import { PopularCarBrands, VehicleListByBrand } from ".";
import { _postURL } from "../../pages/api";
import { _getAllVehicleTopList, _getNextNewsList, _getDealerList, _getAllVehicleModelList } from "../../libraries/common";
import { useRouter } from "next/router";
import { mobileViewWidth, pageLink } from "../../config/site";
import { SkeletonParagraph } from "../common/skeleton";
import { Skeleton } from "@mantine/core";
import Redux from "@/action";
import { Footer } from "../common/footer";
import Head from "next/head";
import { AllMeta } from '@/components/common/meta';
import Link from "next/link";
import { MyBody } from "../body/body";
import { CustomLink } from "../app/customLink";

const VehicleNewVideo = (props) => {
    const { data, brandName, t, type = 1, loading = false } = props
    const [opened, setOpened] = useState(false)
    const [videoUrl, setVideoUrl] = useState(undefined)
    const router = useRouter()

    let title = "News in Malaysia";
    if(type == 2){
        title = "Video in Malaysia";
    }

    if(loading == true){
        return (
            <div className='vehicleNews'>
                <div className='containerPadding'>
                    <p className='fontSize_16 fontWeight_bold'>
                        {brandName} {title}
                    </p>
                </div>
                <ScrollContainer className='vehicleNewsScrollContainer'>
                    <div className='vehicleNewsScrollContainerWrap containerPadding'>
                        {
                            _.times(2, (key)=>(
                                <div key={key} className='vehicleNewsItem'>
                                    <div className='vehicleNewsItemBox' >
                                        <div className='vehicleNewssItemBox_ImageOuter'>
                                            <div className='vehicleNewssItemBox_Image'>
                                                <div className="absoluteSkeletonBox">
                                                    <Skeleton height={'100%'} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='vehicleNewssItemBox_Content'>
                                            <div className='fontSize_14 fontWeight_semiBold vehicleNewssItemBox_Content_title'>
                                                <SkeletonParagraph row={2} isTitle />
                                            </div>
                                            {
                                                type == 1 &&
                                                <div className='vehicleNewssItemBox_ContentBottom'>
                                                    <div className=''>
                                                        {/* <TagButton t={t} /> */}
                                                    </div>
                                                    <div className='fontSize_12'>
                                                        <SkeletonParagraph row={1} isDate />
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </ScrollContainer>
            </div>
        )
    }
    if(_.isEmpty(data)){
        return (<></>)
    }

    const _handleOnclick = (type, value) =>{
        if(type == 1){
            router.push(`${pageLink.news.newsMidUrl + value.link}`)
        } else if( type == 2){
            setVideoUrl(value.youtube_url)
            setOpened(true)
        }
    }

    return (
        <>
            <div className='vehicleNews'>
                <div className='containerPadding'>
                    <p className='fontSize_16 fontWeight_bold'>
                        {brandName} {title}
                    </p>
                </div>
                <ScrollContainer className='vehicleNewsScrollContainer'>
                    <div className='vehicleNewsScrollContainerWrap containerPadding'>
                        {
                            _.reduce(data, (result, value, key)=>{
                                result.push(
                                    <div key={key} className='vehicleNewsItem'>
                                        <div className='vehicleNewsItemBox' >
                                            {
                                                type == 2 ? 
                                                <CustomLink href={`${pageLink.news.newsMidUrl}${value?.custom_url}`}>
                                                    <div 
                                                        // onClick={()=>{_handleOnclick(type, value)}} 
                                                        className='vehicleNewssItemBox_ImageOuter cursor'
                                                    >
                                                        <div className='vehicleNewssItemBox_Image' style={{backgroundImage: `url(${value.thumbnail})`}}>
                                                            <PlayButton />
                                                        </div>
                                                    </div>
                                                </CustomLink>
                                                :
                                                <CustomLink href={`${pageLink.news.newsMidUrl}${value?.custom_url}`}>
                                                    <div 
                                                        // onClick={()=>{_handleOnclick(type, value)}} 
                                                        className='vehicleNewssItemBox_ImageOuter cursorPointer'
                                                    >
                                                        <div className='vehicleNewssItemBox_Image' style={{backgroundImage: `url(${process.env.NEXT_PUBLIC_FS_URL + value.cover_image})`}} />
                                                    </div>
                                                </CustomLink>
                                            }
                                            
                                            <div className='vehicleNewssItemBox_Content'>
                                                <CustomLink href={`${pageLink.news.newsMidUrl}${value?.custom_url}`}>
                                                    <p 
                                                        // onClick={()=>{_handleOnclick(type, value)}} 
                                                        className='fontSize_14 fontWeight_semiBold vehicleNewssItemBox_Content_title cursorPointer'
                                                    >
                                                        {value.title}
                                                    </p>
                                                </CustomLink>
                                                {
                                                    type == 1 &&
                                                    <div className='vehicleNewssItemBox_ContentBottom'>
                                                        {
                                                            _.reduce(JSON.parse(value?.vehicle_brand_tag), (result2, value2, key2)=>{
                                                                if(!_.isEmpty(value2)){
                                                                    result2.push(
                                                                        <TagButton key={`${key}-${key2}`} label={value2.name} linkUrl={pageLink.vehicle.vehicleMidUrl + value2.custom_url} />
                                                                    )
                                                                }
                                                                return result2
                                                            },[])
                                                        }
                                                        <div className="vehicleNewssItemBox_ContentBottom_dateFakePadding" />
                                                    </div>
                                                }
                                                {
                                                    type == 1 &&
                                                    <div className="vehicleNewssItemBox_ContentBottom_date">
                                                        <p className='fontSize_12'>
                                                            {value.created_time}
                                                        </p>
                                                    </div>
                                                }
                                                
                                            </div>
                                        </div>
                                    </div>
                                )
                                return result
                            },[])
                        }
                    </div>
                </ScrollContainer>
            </div>
            {/* {
                type == 2 &&
                <VideoModal 
                    opened={opened}
                    setOpened={setOpened}
                    videoLink={videoUrl}
                />
            } */}
        </>
    )
}

export const VehicleBrands = (props) => {
    const { t, device, session, params, fetchedData, query } = props
    const { store, dispatch } = Redux();
    const [loading, setLoading] = useState(true)
    const [loading2, setLoading2] = useState(true)
    const containerRef = useRef(null)
    
    // category
    const [activeCategory, setActiveCategory] = useState(0)

    // Vehicle model List
    const [vehicleModelList, setVehicleModelList] = useState([])

    // top List brand and model
    const [vehicleTopList, setVehicleTopList] = useState({brand: [], model: []})

    // news list
    const [newsList, setNewsList] = useState([]);
    const [videoList, setVideoList] = useState([])

    // dealer
    const [dealerList, setDealerList] = useState([])
    const [phoneCallOpen, setPhoneCallOpen] = useState(false)
    const [phoneNumberList, setPhoneNumberList] = useState([])

    useEffect(()=>{
        let isMounted = true; // Flag to track component mount status

        const fetchData = async() => {
            try{
                setLoading(true)
                setActiveCategory(0);
                await _getAllVehicleModelList(setVehicleModelList, {
                    vehicleBrandId: fetchedData?.vehicle_brand_id
                });

                if(store?.path?.dataAllVehicleTopList == undefined){
                    await _getAllVehicleTopList(dispatch);
                }

                await _getDealerList({vehicleBrandId: fetchedData?.vehicle_brand_id, limit: 6, offset: 0}, setDealerList)
            } catch(error) {
                console.log(error)
            } finally {
                if (isMounted) {
                    setLoading(false)
                }
            }
        }

        if(fetchedData){
            fetchData();

            if(window.innerWidth <= mobileViewWidth){
                window.scrollTo({
                    top: 1,
                    behavior: 'instant'
                });
            } else {
                if (containerRef.current) {
                    containerRef.current.scrollTo({
                    top: 0,
                    behavior: 'instant'
                    });
                }
            }
        }

        return () => {
            isMounted = false; // Mark the component as unmounted
        };
    },[fetchedData])

    useEffect(()=>{
        let isMounted = true; // Flag to track component mount status

        const fetchData2 = async()=>{
            try{
                setLoading2(true)
                if(!_.isEmpty(vehicleModelList)){
                    const modelIds = vehicleModelList.map(item => item.vehicle_model_id);
                    await _getNextNewsList({limit: 5, type: 1, vehicleModel_id: JSON.stringify(modelIds), willGoEmpty: true, noMergeData: true}, setNewsList) // get news latest 5
                    await _getNextNewsList({limit: 5, type: `2,3`, vehicleModel_id: JSON.stringify(modelIds), willGoEmpty: true, noMergeData: true}, setVideoList) // get video latest 5
                }
            } catch(error) {
                console.log(error)
            } finally {
                if (isMounted) {
                    setLoading2(false)
                }
            }
        }

        if(vehicleModelList){
            fetchData2()
        }

        return () => {
            isMounted = false; // Mark the component as unmounted
        };
    },[vehicleModelList])

    return (
        <>
            <AllMeta
                title={t('vehicleBrandPage_meta_title', {brand: fetchedData?.name})}
                description={t('vehicleBrandPage_meta_description', {brand: fetchedData?.name})}
                keyword={t('vehicleBrandPage_meta_keyword', {brand: fetchedData?.name})}
                image={`${process.env.NEXT_PUBLIC_FS_URL}${fetchedData?.image_path}`}
            />
            <Head><title>{t('vehicleBrandPage_title', {brand: fetchedData?.name})}</title></Head>
            <MyBody
                t={t}
                containerRef={containerRef}
                headerComponent={
                    <HeaderBack 
                        t={t} 
                        searchVisible={false}
                    />
                }
                modalComponent={
                    <PhoneCallListModal
                        phoneCallOpen={phoneCallOpen}
                        setPhoneCallOpen={setPhoneCallOpen} 
                        phoneNumberList={phoneNumberList}
                        t={t}
                    />
                }
            >
                <div className='vehicleBrands_header'>
                    <div className='vehicleBrands_header_inner containerPadding'>
                        <div className='vehicleBrands_header_iconBox'>
                            <div className='vehicleBrands_header_icon' style={{backgroundImage: `url(${process.env.NEXT_PUBLIC_FS_URL + fetchedData?.image_path})`}} />
                        </div>
                        <p className='fontSize_20 fontWeight_bold'>
                            {fetchedData?.name}
                        </p>
                    </div>
                    {
                        vehicleModelList &&
                        <CommonCategory 
                            data={_.chain(vehicleModelList)
                                .map(({ body_type }) => ({ id: body_type, text: body_type }))
                                .filter(({ id }) => id !== '-')
                                .uniqBy('id')
                                .value()
                            }
                            activeCategory={activeCategory}
                            setActiveCategory={setActiveCategory}
                            t={t}
                            loading={loading}
                        />
                    }
                    
                </div>
                <VehicleListByBrand 
                    data={
                        activeCategory != "0" ? 
                        _.chain(vehicleModelList)
                        .filter(obj => obj.body_type === activeCategory)
                        .orderBy(obj => {
                            const variantObj = JSON.parse(obj.variant_object);
                            return variantObj.min_price === 0 ? Infinity : variantObj.min_price;
                        }, ['asc'])
                        .value()
                        : 
                        _.chain(vehicleModelList)
                        .orderBy(obj => {
                            const variantObj = JSON.parse(obj.variant_object);
                            return variantObj.min_price === 0 ? Infinity : variantObj.min_price;
                        }, ['asc'])
                        .value()
                    } 
                    t={t} 
                    loading={loading}
                />
                <VehicleNewVideo data={newsList} t={t} brandName={fetchedData?.name} loading={loading2} />
                <div className="vehicleBrandsPlacementMargin">
                </div>
                <VehicleNewVideo data={videoList} type={2} t={t} brandName={fetchedData?.name} loading={loading2} />
                <DealerSection 
                    t={t} 
                    data={dealerList} 
                    brandName={fetchedData?.name} 
                    brandCustomUrl={query?.vehicle[0]}
                    loading={loading} 
                    setPhoneNumberList={setPhoneNumberList}
                    setPhoneCallOpen={setPhoneCallOpen}
                />
                <div className="vehicleBrandsPopularCarMargin">
                    <PopularCarBrands t={t} data={store?.path?.dataAllVehicleTopList?.brand} loading={store?.path?.dataAllVehicleTopList == undefined ? true : false} />
                </div>
            </MyBody>
        </>
    )
}